import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonWageReportMenu',
  props: {
    savedWageCount: { default: 0 },
    employeeCount: { default: 0 },
    canViewAccountingReport: { type: Boolean, default: false },
    showNontaxSection: { type: Boolean, default: true },
    slipDisabled: { type: Boolean, default: true },
    slipLabel: { default: '명세서 PDF' },
    isAdmin: { type: Boolean, default: false },
    isSuperAdmin: { type: Boolean, default: false }
  },
  emits: ["accounting-report", "client-report", "wage-slip", "nontax-monthly", "nontax-yearly", "transaction", "retirement-compare"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, { location: "bottom" }, {
    activator: _withCtx(({ props: menuProps }) => [
      _createVNode(_component_v_btn, _mergeProps({
        variant: "flat",
        class: "btn-refresh toolbar-report-menu-btn",
        size: "small"
      }, menuProps), {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { size: "14" }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode("mdi-file-chart-outline", -1)
            ]))]),
            _: 1
          }),
          _cache[9] || (_cache[9] = _createTextVNode(" 보고서 ", -1)),
          _createVNode(_component_v_icon, { size: "14" }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode("mdi-chevron-down", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }, 16)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_list, {
        density: "compact",
        class: "wage-report-menu-list"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list_subheader, { class: "wage-report-menu-subheader" }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
              _createTextVNode("임금대장", -1)
            ]))]),
            _: 1
          }),
          (__props.canViewAccountingReport)
            ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 0,
                disabled: __props.savedWageCount === 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('accounting-report')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                      _createTextVNode("회계처리용", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_list_item, {
            disabled: __props.savedWageCount === 0,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('client-report')))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, null, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode("임금대장", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_v_divider, { class: "wage-report-menu-divider" }),
          _createVNode(_component_v_list_item, {
            disabled: __props.slipDisabled,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('wage-slip')))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.slipLabel), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_v_divider, { class: "wage-report-menu-divider" }),
          (__props.showNontaxSection)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_v_list_subheader, { class: "wage-report-menu-subheader" }, {
                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                    _createTextVNode("임금개선", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_list_item, {
                  disabled: __props.savedWageCount === 0,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('nontax-monthly')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                        _createTextVNode("월별 분석", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_list_item, {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (emit('nontax-yearly')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                        _createTextVNode("연간 분석", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true),
          (__props.isAdmin)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createVNode(_component_v_divider, { class: "wage-report-menu-divider" }),
                _createVNode(_component_v_list_item, {
                  disabled: __props.employeeCount === 0,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (emit('transaction')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, { class: "wage-report-menu-item-with-chip" }, {
                      default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                        _createTextVNode(" 거래명세서 ", -1),
                        _createElementVNode("span", { class: "admin-only-chip" }, "관리자", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ], 64))
            : _createCommentVNode("", true),
          (__props.isSuperAdmin)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createVNode(_component_v_divider, { class: "wage-report-menu-divider" }),
                _createVNode(_component_v_list_subheader, { class: "wage-report-menu-subheader" }, {
                  default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                    _createTextVNode("점검", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_list_item, {
                  disabled: __props.savedWageCount === 0,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (emit('retirement-compare')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, { class: "wage-report-menu-item-with-chip" }, {
                      default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                        _createTextVNode(" 퇴직금 비교 ", -1),
                        _createElementVNode("span", { class: "admin-only-chip admin-only-chip--super" }, "최고관리자", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})